import { render, staticRenderFns } from "./NovoAtendimento.vue?vue&type=template&id=780e2d98"
import script from "./NovoAtendimento.vue?vue&type=script&lang=ts"
export * from "./NovoAtendimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports